export const CACHE_BUSTING_VERSION = '2026_2';

export const PHASES = {
    LAUNCHING_SOON: 'LAUNCHING_SOON',
    VOTE: 'VOTE',
    VOTE_ENDED: 'VOTE_ENDED',
    FINALISTS: 'FINALISTS',
    WINNERS: 'WINNERS',
}

// NOTE: THESE ARE END TIMES, NOT START TIMES!!!
export const PHASE_END_TIMES = {
    // Testing times
    // LAUNCHING_SOON: 1725364500,         // Tuesday, September 3, 2024 12:55:00 PM GMT+01:00 (BST)
    // Tuesday, September 3, 2024 12:55:00 PM GMT+01:00 (BST)

    // Real times
    // Real switch over time: 1782860460 // Wednesday, 1 July 2026 at 0:01:00
    LAUNCHING_SOON: 1782860460, // 1782860460 Wednesday, 1 July 2026 at 0:01:00
    // Voting starts 1 July 2026 at 0:01:00 BST

    // Settings voting ends and finalists to a long off date until we get the proper dates
    VOTE: 1782860461,                   // 1754089140 = Friday, August 1, 2025 11:59:00 PM GMT+01:00
    VOTE_ENDED: 1787698860,             // 1787698860 = 1 min past midnight on 26th August 2026
    FINALISTS: 2893456002,              // Real winner reveal 1731618000 Thursday, November 14, 2024 9:00:00 PM // 1731595806 = 14th November 2024 00:14:50am GMT (for testing)
    WINNERS: 2893456003,                // Way off in the future, like 2061!
}

export const PHASES_ORDER = [
    PHASES.LAUNCHING_SOON,
    PHASES.VOTE,
    PHASES.VOTE_ENDED,
    PHASES.FINALISTS,
    PHASES.WINNERS,
]

export function getPhase() {
    if (ALLOW_PHASE_OVERRIDE_IN_URL && new URLSearchParams(window.location.search).has('phase')) {
        const phase = new URLSearchParams(window.location.search).get('phase');
        if (Object.values(PHASES).includes(phase)) {
            return {
                phase: phase,
                timeLeft: 0,
            };
        }
    }
    if (FORCE_PHASE) {
        return {
            phase: FORCE_PHASE,
            timeLeft: 0,
        };
    }

    const now = Math.floor(Date.now() / 1000);
    for (let phase of PHASES_ORDER) {
        if (PHASE_END_TIMES[phase] && now < PHASE_END_TIMES[phase]) {
            return {
                phase: phase,
                timeLeft: PHASE_END_TIMES[phase] ? PHASE_END_TIMES[phase] - now : 0,
            };
        }
    }
    return {
        phase: PHASES.WINNERS,
        timeLeft: 0,
    };
}

// Set to null to go with the timed phases
const ALLOW_PHASE_OVERRIDE_IN_URL = false;
const FORCE_PHASE = null; // PHASES.VOTE_ENDED; // PHASES.LAUNCHING_SOON; //null; // PHASES.FINALISTS; //  PHASES.VOTE; // PHASES.WINNERS; // null; // PHASES.VOTE_ENDED;
export const FORCE_RESTAURANT_PLACEHOLDER = false;
